export function LogoColorfulIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='29' height='24' viewBox='0 0 29 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.97335 0C6.16697 0 7.9467 1.80498 7.9467 4.02973V14.3979C7.9467 16.6226 6.16697 18.4276 3.97335 18.4276C1.77973 18.4276 0 16.6226 0 14.3979V4.02973C0 1.80498 1.77973 0 3.97335 0Z'
        fill='url(#paint0_linear_19704_26321)'
      />
      <path
        d='M14.196 5.57238C16.3896 5.57238 18.1694 7.37736 18.1694 9.60211V19.9703C18.1694 22.195 16.3896 24 14.196 24C12.0024 24 10.2227 22.195 10.2227 19.9703V9.60211C10.2227 7.37736 12.0024 5.57238 14.196 5.57238V5.57238Z'
        fill='url(#paint1_linear_19704_26321)'
      />
      <path
        d='M24.4196 0.430258C26.6133 0.430258 28.393 2.23524 28.393 4.45999V18.669C28.393 20.8937 26.6133 22.6987 24.4196 22.6987C22.226 22.6987 20.4463 20.8937 20.4463 18.669V4.45999C20.4463 2.23524 22.226 0.430258 24.4196 0.430258V0.430258Z'
        fill='url(#paint2_linear_19704_26321)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_19704_26321'
          x1='9.58156'
          y1='-4.2606'
          x2='-0.824933'
          y2='20.0646'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4C519E' />
          <stop offset='1' stopColor='#EA4A91' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_19704_26321'
          x1='19.8042'
          y1='1.30129'
          x2='9.39773'
          y2='25.6265'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4C519E' />
          <stop offset='1' stopColor='#5EB6E7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_19704_26321'
          x1='28.8793'
          y1='1.93091'
          x2='18.3439'
          y2='24.0537'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EE724B' />
          <stop offset='1' stopColor='#FBBF47' />
        </linearGradient>
      </defs>
    </svg>
  )
}
